import { AbstractProductService } from '@qover/services';
import { Contract as DraftProtos } from '@qover-private/protos-web/qover/dojo/travel/v1/contract';
import { Draft } from '../domain/Draft';
import * as DraftFactory from '../domain/factories/DraftFactory';
import * as DraftMapper from '../domain/mappers/DraftMapper';

export class ProductService extends AbstractProductService<Draft, DraftProtos> {
  toJson(payload: Draft): DraftProtos {
    return DraftMapper.mapToApiRequest(payload);
  }

  fromJson(response: DraftProtos): Draft {
    return DraftFactory.createFromApiResponse(response);
  }
}

export const productService = new ProductService('travel');
